import React from 'react';
import { MessageProperties } from '../../../../types';
import facetsTogglerStyles from './facetsToggler.module.pcss';
import ShowFiltersIcon from '../../../../../../svg/icons/filters-show.svg';
import HideFiltersIcon from '../../../../../../svg/icons/filters-hide.svg';

interface FacetsTogglerProps {
  messages: MessageProperties;
  isDisabled: boolean;
  isFacetsDisplayed: boolean;
  isFiltersApplied: boolean;
  onClickHandler: () => void;
}

function FacetsToggler({
  messages,
  isDisabled,
  isFacetsDisplayed,
  isFiltersApplied,
  onClickHandler
}: FacetsTogglerProps): React.ReactElement {
  const styles = { ...facetsTogglerStyles };
  return (
    <button
      type="button"
      disabled={isDisabled}
      onClick={onClickHandler}
      className={`${styles['facets-toggler']} ${isFiltersApplied ? styles['facets-toggler--filters-applied'] : ''} ${
        isFacetsDisplayed ? styles['facets-toggler--facets-displayed'] : ''
      }`}
    >
      <ShowFiltersIcon className={`${styles['facets-toggler__icon']} ${styles['facets-toggler__icon--open']}`} />
      <HideFiltersIcon className={`${styles['facets-toggler__icon']} ${styles['facets-toggler__icon--close']}`} />
      <span className={styles['facets-toggler__show-filters-label']}>{messages.title}</span>
      <span className={styles['facets-toggler__filters-applied-label']}>{messages.appliedFiltersTitle}</span>
      <span className={styles['facets-toggler__hide-filters-label']}>{messages.hideFiltersTitle}</span>
    </button>
  );
}

export default FacetsToggler;
